<template>
  <a-form
    :model="formModel"
    layout="vertical"
    :disabled="loading"
    v-if="selectedLabelTemplateObject"
  >
    <a-flex gap="middle" align="center">
      <a-form-item
        label="Тип объекта"
        name="labelTemplateObjectTypeField"
        v-if="labelTemplateObjectTypeFieldShow"
      >
        <a-select
          :options="labelTemplateFormStore.labelTemplateObjectTypeOptions"
          v-model:value="labelTemplateFormStore.labelTemplateObjectTypeField"
        ></a-select>
      </a-form-item>

      <a-form-item
        label="Тип текста"
        name="labelTemplateTextTypeField"
        v-if="labelTemplateTextTypeFieldShow"
      >
        <a-select
          :options="labelTemplateFormStore.labelTemplateTextTypeOptions"
          v-model:value="labelTemplateFormStore.labelTemplateTextTypeField"
        ></a-select>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Выравнивание"
        name="alignmentTypeField"
        v-if="alignmentTypeFieldShow"
      >
        <a-select
          :options="
            labelTemplateFormStore.labelTemplateObjectAlignmentTypeOptions
          "
          v-model:value="labelTemplateFormStore.alignmentTypeField"
        ></a-select>
      </a-form-item>

      <a-form-item
        label="Тип штрихкода"
        name="barcodeTypeField"
        v-if="barcodeTypeFieldShow"
      >
        <a-select
          :options="labelTemplateFormStore.barcodeTypeOptions"
          v-model:value="labelTemplateFormStore.barcodeTypeField"
        ></a-select>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Высота штрихкода, мм"
        name="barcodeHeightInMmField"
        v-if="barcodeHeightInMmFieldShow"
      >
        <a-input-number
          :min="0"
          :step="1"
          v-model:value="labelTemplateFormStore.barcodeHeightInMmField"
        ></a-input-number>
      </a-form-item>

      <a-form-item
        :label="barcodeSizeFieldLabel"
        name="barcodeSizeField"
        v-if="barcodeSizeFieldShow"
      >
        <a-input-number
          :min="0"
          :step="0.1"
          v-model:value="labelTemplateFormStore.barcodeSizeField"
        ></a-input-number>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Текст штрихкода"
        name="displayBarcodeTextField"
        v-if="displayBarcodeTextFieldShow"
      >
        <a-input
          v-model:value="labelTemplateFormStore.displayBarcodeTextField"
        ></a-input>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Обычный текст"
        name="plainTextField"
        v-if="plainTextFieldShow"
      >
        <a-input v-model:value="labelTemplateFormStore.plainTextField" />
      </a-form-item>

      <a-form-item
        label="Положение текста"
        name="plainTextPositionField"
        v-if="plainTextPositionFieldShow"
      >
        <a-select
          :options="labelTemplateFormStore.labelObjectPlainTextPositionOptions"
          v-model:value="labelTemplateFormStore.plainTextPositionField"
        ></a-select>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Свойства объекта"
        name="domainObjectPropertyTypeField"
        v-if="domainObjectPropertyTypeFieldShow"
      >
        <a-select
          mode="tags"
          :options="labelTemplateFormStore.domainObjectPropertyTypeOptions"
          v-model:value="labelTemplateFormStore.domainObjectPropertyTypeField"
        ></a-select>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Шрифт текста"
        name="textFontField"
        v-if="textFontFieldShow"
      >
        <a-select
          :options="labelTemplateFormStore.textFontFieldOptions"
          v-model:value="labelTemplateFormStore.textFontField"
        ></a-select>
      </a-form-item>

      <a-form-item
        label="Размер текста"
        name="textSizeField"
        v-if="textSizeFieldShow"
      >
        <a-input-number
          v-model:value="labelTemplateFormStore.textSizeField"
          :min="1"
        ></a-input-number>
      </a-form-item>
    </a-flex>

    <a-flex gap="middle" align="center">
      <a-form-item
        label="Разрешить перенос строк"
        name="enableLineBreaksField"
        v-if="enableLineBreaksFieldShow"
      >
        <a-switch
          v-model:checked="labelTemplateFormStore.enableLineBreaksField"
        ></a-switch>
      </a-form-item>

      <a-form-item
        label="Количество строк"
        name="numberOfMaximumNumberOfLinesField"
        v-if="numberOfMaximumNumberOfLinesFieldShow"
      >
        <a-input-number
          v-model:value="
            labelTemplateFormStore.numberOfMaximumNumberOfLinesField
          "
          :min="1"
        ></a-input-number>
      </a-form-item>
    </a-flex>
  </a-form>
</template>

<script setup lang="ts">
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { storeToRefs } from "pinia";
import { computed, watch } from "vue";
import {
  LabelTemplateObjectType,
  LabelTemplateTextType,
} from "@/api/classes/labelTemplate/labelTemplate.dto";

defineProps<{ loading: boolean }>();

const labelTemplateFormStore = useLabelTemplateFormStore();

const {
  labelTemplateObjectTypeField,
  labelTemplateTextTypeField,
  alignmentTypeField,
  plainTextField,
  textFontField,
  textSizeField,
  enableLineBreaksField,
  numberOfMaximumNumberOfLinesField,
  plainTextPositionField,
  domainObjectPropertyTypeField,
  barcodeTypeField,
  barcodeSizeField,
  barcodeHeightInMmField,
  displayBarcodeTextField,
  selectedLabelTemplateObject,
} = storeToRefs(labelTemplateFormStore);

const formModel = computed(() => ({
  labelTemplateObjectTypeField: labelTemplateObjectTypeField.value,
  labelTemplateTextTypeField: labelTemplateTextTypeField.value,
  alignmentTypeField: alignmentTypeField.value,
  plainTextField: plainTextField.value,
  textFontField: textFontField.value,
  textSizeField: textSizeField.value,
  enableLineBreaksField: enableLineBreaksField.value,
  numberOfMaximumNumberOfLinesField: numberOfMaximumNumberOfLinesField.value,
  plainTextPositionField: plainTextPositionField.value,
  domainObjectPropertyTypeField: domainObjectPropertyTypeField.value,
  barcodeTypeField: barcodeTypeField.value,
  barcodeSizeField: barcodeSizeField.value,
  barcodeHeightInMmField: barcodeHeightInMmField.value,
  displayBarcodeTextField: displayBarcodeTextField.value,
}));

const labelTemplateObjectTypeFieldShow = computed(() => true);
const labelTemplateTextTypeFieldShow = computed(() =>
  [LabelTemplateObjectType.Text].includes(labelTemplateObjectTypeField.value),
);
const alignmentTypeFieldShow = computed(() =>
  [
    LabelTemplateObjectType.Text,
    LabelTemplateObjectType.Barcode,
    LabelTemplateObjectType.CurrentDateAndTimeOfTheUserMachine,
  ].includes(labelTemplateObjectTypeField.value),
);
const plainTextFieldShow = computed(() =>
  [LabelTemplateObjectType.Text].includes(labelTemplateObjectTypeField.value),
);
const textFontFieldShow = computed(() =>
  [
    LabelTemplateObjectType.Text,
    LabelTemplateObjectType.CurrentDateAndTimeOfTheUserMachine,
  ].includes(labelTemplateObjectTypeField.value),
);
const textSizeFieldShow = computed(() =>
  [
    LabelTemplateObjectType.Text,
    LabelTemplateObjectType.CurrentDateAndTimeOfTheUserMachine,
    LabelTemplateObjectType.Barcode,
  ].includes(labelTemplateObjectTypeField.value),
);
const enableLineBreaksFieldShow = computed(() =>
  [LabelTemplateObjectType.Text].includes(labelTemplateObjectTypeField.value),
);
const numberOfMaximumNumberOfLinesFieldShow = computed(() =>
  [LabelTemplateObjectType.Text].includes(labelTemplateObjectTypeField.value),
);
const plainTextPositionFieldShow = computed(
  () =>
    [LabelTemplateObjectType.Text].includes(
      labelTemplateObjectTypeField.value,
    ) &&
    labelTemplateTextTypeField.value ===
      LabelTemplateTextType.DomainObjectProperty,
);
const domainObjectPropertyTypeFieldShow = computed(
  () =>
    [LabelTemplateObjectType.Text].includes(
      labelTemplateObjectTypeField.value,
    ) &&
    labelTemplateTextTypeField.value ===
      LabelTemplateTextType.DomainObjectProperty,
);
const barcodeTypeFieldShow = computed(() =>
  [LabelTemplateObjectType.Barcode].includes(
    labelTemplateObjectTypeField.value,
  ),
);
const barcodeSizeFieldShow = computed(() =>
  [
    LabelTemplateObjectType.Barcode,
    LabelTemplateObjectType.SupplyBarcode,
    LabelTemplateObjectType.BoxBarcode,
    LabelTemplateObjectType.FbsOzonBarcode,
    LabelTemplateObjectType.Logo,
    LabelTemplateObjectType.FbsWBBarcode,
  ].includes(labelTemplateObjectTypeField.value),
);
const barcodeHeightInMmFieldShow = computed(() =>
  [
    LabelTemplateObjectType.Barcode,
    LabelTemplateObjectType.BoxBarcode,
  ].includes(labelTemplateObjectTypeField.value),
);
const displayBarcodeTextFieldShow = computed(() =>
  [LabelTemplateObjectType.Barcode].includes(
    labelTemplateObjectTypeField.value,
  ),
);

const barcodeSizeFieldLabel = computed(() =>
  labelTemplateObjectTypeField.value === LabelTemplateObjectType.Logo
    ? "Масштаб изображения"
    : "Размер штрихкода",
);

watch(
  () => labelTemplateObjectTypeField.value,
  () => {
    if (!labelTemplateFormStore.selectedLabelTemplateObject) return;

    const label = labelTemplateFormStore.getLabelTemplateObjectDataFromStringId(
      labelTemplateFormStore.selectedLabelTemplateObject,
    );

    const [_, index] =
      labelTemplateFormStore.selectedLabelTemplateObject.split("_");

    labelTemplateFormStore.selectedLabelTemplateObject =
      labelTemplateFormStore.getLabelTemplateObjectStringId(label, +index);
  },
);
</script>

<style scoped lang="scss">
.ant-form {
  width: 350px;

  .ant-form-item {
    flex: 1 1 50%;

    :deep(.ant-input-number) {
      width: 100%;
    }
  }
}
</style>
